import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class SamsungDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default SamsungDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/samsung/DeviceSetup.js